<template>
  <div id="app">
    <myNav></myNav>
    <router-view></router-view>
    <Myfooter></Myfooter>
  </div>
</template>

<script>
import myNav from './components/layout/myNav.vue'
import Myfooter from './components/layout/footer.vue'

export default {
  name: 'app',
  components: {
    myNav,
    Myfooter
  }
}
</script>

<style lang="scss">
body {
  margin: 0;
  overflow-x: hidden;
}
@media (max-width: 900px) {
  html {
    font-size: 19px; // 或 20、22，自己看手机上舒服就行
  }
}
</style>
